<template>
  <div>
    <b-card border-variant="dark">
      <div class="height-queue">
        <span class="font-weight-bold font-15">Clientes na URA</span>
        <input type="text" class="form-control mb-2" v-model="searchTerm" placeholder="Pesquisar nome ou telefone..." />
        <b-table
          id="queue"
          small
          striped
          bordered
          fixed
          :per-page="perPage"
          :fields="fields"
          :items="items"
          responsive="sm"
          class="mt-2"
          :current-page="currentPage"
          show-empty
        >
          <template #empty>
            <h6 class="text-center">Nenhum cliente na URA</h6>
          </template>

          <template #cell(time)="data">
            <b-badge :variant="getTime(data.item.time).variant">{{ getTime(data.item.time).val }}</b-badge>
          </template>

          <template #cell(opcao)="data">
            <i title="Visualizar conversa" id="action-button-view" class="image-button fa fa-eye" @click.prevent="abrirVisualizar(data.item.opcao)"></i>
            <i title="Direcionar atendimento" id="action-button-invite" class="image-button fa fa-reply" @click="$emit('open-modal-transf', data.item.opcao)"></i>
            <i title="Excluir atendimento" id="action-button-delete" class="image-button fas fa-trash" @click.prevent="emitDelete(data.item.opcao)"></i>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage" aria-controls="queue" size="sm" align="right"></b-pagination>
      </div>
    </b-card>
    <dtModalVisualizarUra ref="dtModalVisualizarUra"/>
  </div>
</template>

<script>
export default {
  name: "TbFilaURA",
  props: {
    queues: { type: Array, default: () => [] },
  },
  data: () => ({
    fields: [
      {key: 'nome',  label: 'Cliente',  class: 'text-center align-middle', thStyle: {'font-weight': 'bold'}},
      {key: 'phone', label: 'Telefone', class: 'text-center align-middle', thStyle: { width: "160px", 'font-weight': 'bold' }},
      {key: 'time',  label: 'Tempo',    class: 'text-center align-middle', thStyle: {'font-weight': 'bold'}},
      {key: 'opcao', label: 'Ações',    class: 'text-center align-middle', thStyle: { width: "120px", 'font-weight': 'bold' }}
    ],
    currentPage: 1,
    perPage: 10,
    searchTerm: '',
  }),
  computed: {
    rows(){ return this.items.length; },
    items(){
      const now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      const termo = this.searchTerm.toLowerCase();
      const termoDigits = this.searchTerm.replace(/\D/g,'');
      return (this.queues || [])
        .map(q => {
          const ms = moment(now).diff(moment(q.created_at));
          const seconds = moment.duration(ms).asSeconds();
          const clientId = (q.client_id || '').toString();
          return {
            nome: q.client ? q.client : q.cName,
            phone: this.formTelefone(clientId),
            phoneDigits: clientId.replace(/\D/g,''),
            time: Number.isFinite(seconds) ? seconds : 0,
            opcao: clientId
          }
        })
        .filter(item => {
          const n = (item.nome || '').toLowerCase();
          const p = (item.phone || '').toLowerCase();
          const pd = item.phoneDigits || '';
          return (
            (termo && (n.includes(termo) || p.includes(termo))) ||
            (termoDigits && pd.includes(termoDigits)) ||
            (!termo && !termoDigits)
          );
        })
        .sort((x,y)=> x.time - y.time);
    },
  },
  methods: {
    abrirVisualizar(idUsers){
      this.$emit('open-conversa', idUsers);
      this.$refs.dtModalVisualizarUra.openModal();
    },
    emitDelete(client){
      this.$emit('delete-item', { client, operadorId: new User().getId() });
    },
    getTime(time) {
      if (isNaN(time)) return { val: '00:00:00', variant: 'success' };
      let horas = ("00" + parseInt(time / 3600)).slice(-2);
      time = time - (horas * 3600);
      let minutos = ("00" + parseInt(time / 60)).slice(-2);
      time = time - (minutos * 60);
      let segundos = ("00" + parseInt(time)).slice(-2);
      const format = `${horas}:${minutos}:${segundos}`;
      if (+horas < 1 && +minutos < 30) return {val: format, variant: 'success'};
      if (+horas < 3) return {val: format, variant: 'warning'};
      return {val: format, variant: 'danger'};
    },
    formTelefone(tel) {
      if(tel.substr(0,2) != '55') return '+' + tel;
      if((tel.length == 10) || (tel.length == 11)) {
        const v1 = tel.replace(/\D/g,"");
        const v2 = v1.replace(/^(\d{2})(\d)/g,"($1) $2");
        const v3 = v2.replace(/(\d)(\d{4})$/,"$1-$2");
        return v3;
      }
      tel=tel.replace(/\D/g,"");
      tel=tel.replace(/^(\d)/,"+$1");
      tel=tel.replace(/(.{3})(\d)/,"$1($2");
      tel=tel.replace(/(.{6})(\d)/,"$1)$2");
      if(tel.length == 12) tel=tel.replace(/(.{1})$/,"-$1");
      else if (tel.length == 13) tel=tel.replace(/(.{2})$/,"-$1");
      else if (tel.length == 14) tel=tel.replace(/(.{3})$/,"-$1");
      else if (tel.length == 15) tel=tel.replace(/(.{4})$/,"-$1");
      else if (tel.length > 15) tel=tel.replace(/(.{4})$/,"-$1");
      tel=tel.replace("("," (");
      tel=tel.replace(")",") ");
      return tel;
    },
  }
}
</script>

<style scoped>
.card {
  color: black !important;
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
  border-radius: 0.25rem !important;
}
.font-15 { font-size: 15px; }
.height-queue { }
#action-button-view { cursor: pointer; font-size: 16px; color: #1c869a; transition: 0.25s; margin: 5px; }
#action-button-view:hover { color: #177081; }
#action-button-delete { cursor: pointer; font-size: 16px; color: #e3342f; transition: 0.25s; margin: 5px; }
#action-button-delete:hover { color: #b42a26; }
#action-button-invite { cursor: pointer; font-size: 16px; color: black; transition: 0.25s; margin: 5px; }
#action-button-invite:hover { color: #424242; }
</style>
